"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Total = void 0;
const React = __importStar(require("react"));
const Total = (props) => {
    const onBlur = (e) => {
        props.changeTotal(e.target.value);
    };
    return React.createElement("div", { className: "field" },
        React.createElement("label", { className: "label" }, "Total budget"),
        React.createElement("div", { className: "control" },
            React.createElement("input", { className: "input is-primary", type: "text", placeholder: "Primary input", onBlur: onBlur, defaultValue: props.total })));
};
exports.Total = Total;
